import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Analytics
import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../actions/alertActions';
import { createIssue } from '../actions/issueActions';

// Components
import { Button } from '@mui/material';
import Alert from '../components/common/Alert';

// Initial State
const initialState = {
    email: '',
    issue: ''
}

const Report_Issues = ({
    setAlert,
    createIssue,
    nav: {
        issue_processing
    }
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // State for form data
    const [formData, setFormData] = useState(initialState);

    // Destructure the email value from form data
    const { email, issue } = formData;

    // Function to handle input change
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Function to validate email format
    const validateEmail = (input) => {

        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      
        if (input.match(validRegex)) {
      
          return true;
      
        } else {
      
          return false;
      
        }
    }

    // Function to handle form submission
    const onSubmit = async e => {
        e.preventDefault();

        if(email === '') {
            setAlert('Email is required.', 'danger');
        } else if (!validateEmail(email)) {
            setAlert('Invalid email address!', 'danger');
        } else if (issue === '') {
            setAlert('Please enter an issue.', 'danger');
        } else {

            // Send issue
            createIssue({email, issue})

            setFormData(initialState);
        }
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
        mixpanel.track("Report Issue Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    return (
        <Fragment>

            <div className='register_container login'>
                <div className='register_content_container login'>
                    <div className='register_content'>
                        <div style={{boxSizing:'border-box', textAlign:'center'}}>
                            {/* Alert */}
                            <Alert />

                            {/* Title */}
                            <div className='register_title login' style={{marginTop: '1.5rem'}}>
                                Report Issue
                            </div>

                        </div>

                        <div>

                            {/* Input fields */}
                            <div className='register_form_inputs'>
                                    
                                {/* Input & Label */}
                                <div className='register_input_container login'>
                                    <input 
                                        type="text"
                                        placeholder="Email address"
                                        className="input"
                                        name="email"
                                        value={email}
                                        onChange={e => onChange(e)}
                                    />
                                </div>

                                {/* Password*/}
                                <div className='register_input_container login'>
                                    <textarea 
                                        type="text"
                                        placeholder="Please describe the issue you're experiencing..."
                                        className="textarea"
                                        name="issue"
                                        value={issue}
                                        onChange={e => onChange(e)}
                                    />
                                </div>
                            </div>
                
                        </div>

                        {/* Form Actions */}
                        <div className='register_btns' style={{display: 'flex', alignItems:'center', flexDirection:'column'}}>
                            <Button 
                                onClick={onSubmit} 
                                className="sidebar__tweet"
                                fullWidth
                                disabled={issue_processing}
                            > 
                                {issue_processing ? 
                                    'Processing...' : 
                                    'Submit'}
                            </Button>
        
                        </div>     
                        
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

Report_Issues.propTypes = {
    setAlert: PropTypes.func.isRequired,
    createIssue: PropTypes.func.isRequired,
    nav: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setAlert,
    createIssue
})(Report_Issues);